const _state = {
  loading: false,
  isNavOpen: false,
  isMobileDensity: false,
  navOption: {},
  isCaseListOpen: false,
  sidebarBadges: {
    assignmentCount: null,
    documentCount: null,
    commentCount: null,
    trackingCount: null,
  },
  itemModel: {},
  lastNotifyRefreshCaseInfo: null,
  lastNotifyRefreshCaseInfoType: null,
  lastNotifyRefreshCaseInfoValue: null,
  lastRefreshCaseList: null,
  refreshCaseListPayload: null,
  filterViewDetails: null,
  filterBySubType: null,
  assignedRequests: 0,
  sitemapInfo: {
    assignedRequestCount: null,
    routes: [],
    request: {},
  },
};

export const initialState = () => _state;

export const state = initialState();
